import React, { Component } from 'react'
import ProposalSectionPreview from './ProposalSectionPreview'

class ProposalSectionsPreview extends Component {
  renderSection = section => {
    return <ProposalSectionPreview key={section.id || section.tmpId} section={section} />
  }

  render() {
    const { dataStructure } = this.props

    return <ol type="1">{dataStructure && dataStructure.map(this.renderSection)}</ol>
  }
}

export default ProposalSectionsPreview



// WEBPACK FOOTER //
// ./src/components/templates/ProposalSectionsPreview.js